module.exports = __webpack_public_path__ + "img/avatar8.a9f0938e.jpg";